const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  name: (lambdaParameter, value) =>
    `${lambdaParameter}.Name.Contains("${value}")`,
  address: (lambdaParameter, value) =>
    `${lambdaParameter}.Address.Contains("${value}")`,
  search: (lambdaParameter, value) =>
    `${value
      .toString()
      .split(' ')
      .map(
        (q: string) =>
          `(${lambdaParameter}.Id+" "+${lambdaParameter}.Name).Contains("${q}")`,
      )
      .join('&&')}`,
}

const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
